import PropTypes from 'prop-types';
import React from 'react';
import AssetSelectorItem from '../../containers/asset-selector-item.jsx';
import Box from '../box/box.jsx';
import SortableAsset from './sortable-asset.jsx';
import SortableHOC from '../../lib/sortable-hoc.jsx';
import DragConstants from '../../lib/drag-constants';

import styles from './selector.css';

const Selector = props => {
    const {
        assetType,
        containerRef,
        dragType,
        playingIndex,
        items,
        selectedItemIndex,
        disabled,
        draggingType,
        ordering,
        onAddSortable,
        onChangeName,
        onClickPlay,
        onClickStop,
        onRemoveSortable,
        onDeleteClick,
        onDuplicateClick,
        onEditClick,
        onItemClick
    } = props;

    const isRelevantDrag = draggingType === dragType;

    return (
        <Box
            className={styles.wrapper}
            componentRef={containerRef}
        >
            <Box className={styles.listArea}>
                {items.map((item, index) => (
                    <SortableAsset
                        id={item.name}
                        index={isRelevantDrag ? ordering.indexOf(index) : index}
                        key={item.name}
                        onAddSortable={onAddSortable}
                        onRemoveSortable={onRemoveSortable}
                    >
                        <AssetSelectorItem
                            asset={item.asset}
                            assetId={item.assetId}
                            assetType={assetType}
                            costumeURL={item.url}
                            disabled={disabled}
                            dragPayload={item.dragPayload}
                            dragType={dragType}
                            id={index}
                            index={index}
                            isPlaying={playingIndex === index}
                            name={item.name}
                            number={index + 1 /* 1-indexed */}
                            selected={index === selectedItemIndex}
                            onChangeName={onChangeName}
                            onClick={onItemClick}
                            onCopyButtonClick={onDuplicateClick}
                            onDeleteButtonClick={onDeleteClick}
                            onEditButtonClick={onEditClick}
                            onPlayClick={onClickPlay}
                            onStopClick={onClickStop}

                        />
                    </SortableAsset>
                ))}
            </Box>
        </Box>
    );
};

Selector.propTypes = {
    assetType: PropTypes.oneOf(['costume', 'backdrop', 'sound']),
    containerRef: PropTypes.func,
    disabled: PropTypes.bol,
    dragType: PropTypes.oneOf(Object.keys(DragConstants)),
    draggingType: PropTypes.oneOf(Object.keys(DragConstants)),
    isPlaying: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string,
        name: PropTypes.string.isRequired
    })),
    onAddSortable: PropTypes.func,
    onChangeName: PropTypes.func,
    onClickPlay: PropTypes.func,
    onClickStop: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onDuplicateClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onItemClick: PropTypes.func.isRequired,
    onRemoveSortable: PropTypes.func,
    ordering: PropTypes.arrayOf(PropTypes.number),
    selectedItemIndex: PropTypes.number.isRequired
};

export default SortableHOC(Selector);
